const imageContexts: any = {
  vehicleMakeContext: require.context('../../public/images/VehicleMakes', false, /\.(png|jpe?g|svg)$/)
};
export default imageContexts;